export const dark = "dark "
export const side_nav = "Style_side_nav "
export const reset_text = "Style_reset_text "
export const button = "Style_button "
export const button_blue_bright = "Style_button_blue_bright "
export const button_red = "Style_button_red "
export const button_white = "Style_button_white "
export const button_accent = "Style_button_accent "
export const input_like = "Style_input_like "
export const questionnaire = "Style_questionnaire "
export const panel = "Style_panel "
export const composite_filter_container = "Style_composite_filter_container "
export const next_nav_toggled_visible = "Style_next_nav_toggled_visible "
export const toggled_visible = "Style_toggled_visible "
export const is_active = "Style_is_active "
export const nav_counter_seperator = "Style_nav_counter_seperator "
export const next_link_em_down = "Style_next_link_em_down "
export const header_for_side_nav = "Style_header_for_side_nav "
export const full_width_center_800 = "Style_full_width_center_800 "
export const nav_large_top_public = "Style_nav_large_top_public "
export const nav_large_top_student = "Style_nav_large_top_student "
export const header_large_top = "Style_header_large_top "
export const full_width_center_1028 = "Style_full_width_center_1028 "
export const full_width_grey_top_section = "Style_full_width_grey_top_section "
export const body = "Style_body "
export const bg_grey = "Style_bg_grey "
export const cancel_main_margins = "Style_cancel_main_margins "
export const page_title = "Style_page_title "
export const body_off_white = "Style_body_off_white "
export const page_title_breadcrumb = "Style_page_title_breadcrumb "
export const page_title_seperator = "Style_page_title_seperator "
export const layout_seperate_aside = "Style_layout_seperate_aside "
export const delete_panel = "Style_delete_panel "
export const button_has_only_icon = "Style_button_has_only_icon "
export const button_round = "Style_button_round "
export const checkbox = "Style_checkbox "
export const input_with_icon = "Style_input_with_icon "
export const has_error = "has_error "
export const user_is_typing = "user_is_typing "
export const editor_window = "Style_editor_window "
export const readonly_form = "Style_readonly_form "
export const card = "Style_card "
export const card_student_start = "Style_card_student_start "
export const select_like = "Style_select_like "
export const equal_columns = "Style_equal_columns "
export const equal_columns_non_responsive = "Style_equal_columns_non_responsive "
export const icon_container = "Style_icon_container "
export const icon_circle = "Style_icon_circle "
export const table_condensed = "Style_table_condensed "
export const table_has_inputs = "Style_table_has_inputs "
export const text_with_icon = "Style_text_with_icon "
export const flex_responsive = "Style_flex_responsive "
export const button_small = "Style_button_small "
export const button_small_blue = "Style_button_small_blue "
export const button_em_down = "Style_button_em_down "
export const button_green = "Style_button_green "
export const animate_saved_state = "Style_animate_saved_state "
export const saved_state_anim = "saved_state_anim "
export const panel_as_popup = "Style_panel_as_popup "
export const panel_header = "Style_panel_header "
export const is_selected = "Style_is_selected "
export const cancel_card_padding = "Style_cancel_card_padding "
export const card_large = "Style_card_large "
export const grid_card_small = "Style_grid_card_small "
export const grid_card_small_always_three_columns = "Style_grid_card_small_always_three_columns "
export const card_accent = "Style_card_accent "
export const card_white = "Style_card_white "
export const empty_image = "Style_empty_image "
export const card_student_card_links = "Style_card_student_card_links "
export const card_with_icon = "Style_card_with_icon "
export const a_around_button = "Style_a_around_button "
export const icon_on_right = "Style_icon_on_right "
export const helptext = "Style_helptext "
export const loading = "Style_loading "
export const spinAround = "spinAround "
export const remove_on_phone = "Style_remove_on_phone "
export const only_on_phone = "Style_only_on_phone "
export const slide_in = "Style_slide_in "
export const slide_in_anim = "slide_in_anim "
export const hide_next = "Style_hide_next "
export const editor_control_buttons = "Style_editor_control_buttons "
export const editor_control_button = "Style_editor_control_button "
export const editor_control_button_active = "Style_editor_control_button_active "
export const file_input = "Style_file_input "
export const listleftlayout_unread_badge = "Style_listleftlayout_unread_badge "
export const listleftlayout_left = "Style_listleftlayout_left "
export const listleftlayout_left_container = "Style_listleftlayout_left_container "
export const listleftlayout_middle = "Style_listleftlayout_middle "
export const listleftlayout_middle_max_width = "Style_listleftlayout_middle_max_width "
export const listleftlayout_left_item = "Style_listleftlayout_left_item "
export const icon_comment_alt_solid = "Fontawesome_icon_comment_alt_solid "
export const icon_sticky_note = "Fontawesome_icon_sticky_note "
export const listleftlayout_left_item_active = "Style_listleftlayout_left_item_active "
export const messages_message_container = "Style_messages_message_container "
export const messages_message_author = "Style_messages_message_author "
export const messages_message_meta = "Style_messages_message_meta "
export const messages_message_time = "Style_messages_message_time "
export const messages_message_sent_by_counterparty = "Style_messages_message_sent_by_counterparty "
export const messages_message_sent_by_other = "Style_messages_message_sent_by_other "
export const messages_message_sent_by_self = "Style_messages_message_sent_by_self "
export const listleftlayout_back_link = "Style_listleftlayout_back_link "
export const messages_expanding_area = "Style_messages_expanding_area "
export const listleftlayout_main_ = "Style_listleftlayout_main_ "
export const listleftlayout_main_with_selection = "Style_listleftlayout_main_with_selection "
export const notes_delete_button = "Style_notes_delete_button "
export const notes_delete_overlay = "Style_notes_delete_overlay "
export const note_link_content = "Style_note_link_content "
export const note_author = "Style_note_author "
export const note_contents = "Style_note_contents "
export const timeline_left = "Style_timeline_left "
export const timeline_item = "Style_timeline_item "
export const timeline_content = "Style_timeline_content "
export const timeline_number = "Style_timeline_number "
export const timeline_line = "Style_timeline_line "
export const timeline_emphasis = "Style_timeline_emphasis "
export const timeline_number_outline = "Style_timeline_number_outline "
export const autocomplete = "Style_autocomplete "
export const seethrough = "Style_seethrough "
export const formsection_informational = "Style_formsection_informational "
export const panel_tabs = "Style_panel_tabs "
export const radio_one_line = "Style_radio_one_line "
export const yearcalendar_month = "Style_yearcalendar_month "
export const yearcalendar_day = "Style_yearcalendar_day "
export const yearcalendar_day_background = "Style_yearcalendar_day_background "
export const yearcalendar_day_today = "Style_yearcalendar_day_today "
export const yearcalendar_day_selected = "Style_yearcalendar_day_selected "
export const yearcalendar_day_outside_period = "Style_yearcalendar_day_outside_period "
export const yearcalendar_day_weekend = "Style_yearcalendar_day_weekend "
export const yearcalendar_as_text_table = "Style_yearcalendar_as_text_table "
export const popup_backdrop = "Style_popup_backdrop "
export const period_line = "Style_period_line "
export const floating_popup_small_layout = "Style_floating_popup_small_layout "
export const message_on_student_profiles = "Style_message_on_student_profiles "
export const lessongroup_student_row = "Style_lessongroup_student_row "
export const lessongroup_status_indicator = "Style_lessongroup_status_indicator "
export const informational_header = "Style_informational_header "
export const session_full_page = "Style_session_full_page "
export const session_error = "Style_session_error "
export const session_success = "Style_session_success "
export const session_helptext = "Style_session_helptext "
export const session_link_under_card_container = "Style_session_link_under_card_container "
export const session_role_picker = "Style_session_role_picker "
export const popup_dropdown = "Style_popup_dropdown "
export const slide_in_from_bot_anim = "slide_in_from_bot_anim "
export const multiselect_dropdown = "Style_multiselect_dropdown "
export const dashboard_grid = "Style_dashboard_grid "
export const tag = "Style_tag "
export const tag_green = "Style_tag_green "
export const tag_red = "Style_tag_red "
export const tag_accent = "Style_tag_accent "
export const composite_filter = "Style_composite_filter "